// extracted by mini-css-extract-plugin
export default {"l_ArrowIcon_main":"ArrowIcon_l_ArrowIcon_main__Dpysg","l_img":"ArrowIcon_l_img__J2p0-"};